import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from "utils/constants";

export const callShopCharges = async (chargesPaymentType) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, `/charges/shop/${chargesPaymentType}`));
};

export const callPaymentDate = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/payment-type-setting/payment-date'));
};

export const callShopChargesPaymentTokenIssuance = async (paymentType, data) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, `/payment/token-issuance/${paymentType}`, data));
};

export const callGeneralPayment = async (paymentGatewayUrl) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, `${paymentGatewayUrl}`));
};